module.exports = __webpack_public_path__ + "static/media/icon-lock.bd4b2bba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-lock.svg
// module id = ./src/assets/images/icon-lock.svg
// module chunks = 6